/**
 * Note — the page action bar: an advisory message on the left, actions on the right.
 *
 * Ported from the legacy `FooterActions.vue` layout, with one deliberate
 * difference: the legacy bar has NO styling at all (no <style> block; it is a
 * transparent div in normal flow). The card-coloured surface here is a new
 * design decision, not something carried over. Position is faithful though —
 * static, at the end of the page content, scrolling with it rather than pinned.
 *
 * Generic on purpose: Cloud Usage Reports and Telemetry have their own action bars
 * with different copy, so the message and the actions are both supplied by the
 * caller. The only thing baked in is the bold "Note:" prefix.
 *
 *   <Note message="Please upload a file with maximum of 1M records">
 *     <Button variant="secondary">Cancel</Button>
 *     <Button variant="primary">Save</Button>
 *   </Note>
 */
import { cx } from '@lib/classNames';

import styles from './Note.module.css';

export function Note({ label = 'Note:', message, children, className, ...rest }) {
  return (
    <div className={cx(styles.bar, className)} {...rest}>
      <p className={styles.text}>
        {/* The space is explicit: Vue's template whitespace handling supplied
            it in the legacy markup, JSX does not. */}
        <strong className={styles.label}>{label}</strong>{' '}
        <span className={styles.message}>{message}</span>
      </p>

      {children ? <div className={styles.actions}>{children}</div> : null}
    </div>
  );
}

export default Note;
